module.exports = __webpack_public_path__ + "img/spiral.211a65cb.png";